import React from 'react';
import { useSelector } from 'react-redux';

export interface TicketDeviceBinProps {
  ticket: string;
  show: boolean;
}

export const TicketDeviceBin = ({ticket, show}: TicketDeviceBinProps) => {
  const {
    channel,
    device_type,
    device,
    os,
    os_version,
    browser,
    browser_version,
    ip,
    widget_referrer_url
  }: any = useSelector<any>((state) => state.ticket.data[ticket]) || {};

  let ticketDeviceType = device_type ? device_type.charAt(0).toUpperCase() + device_type.slice(1) : "";
  let ticketDevice = device ? device : "";
  let deviceType = `${ticketDeviceType} - ${ticketDevice}`
  let ticketOs = os_version ? `${os} v#${os_version}` : "";
  let ticketBrowser = browser_version ? `${browser} v${browser_version}` : "";
  let ticketIp = ip ? ip : "N/A";
  let ticketReferrer = widget_referrer_url ? widget_referrer_url : "N/A";
  let elementClassName = channel == "live_chat" && show ? "device-bin" : "device-bin hide";

  return (
    <div className={elementClassName} id="device-bin" data-sticky-reveal="true">
      <table className="device-bin-table">
        <tbody>
          <tr>
            <td>Device Type:</td>
            <td>{deviceType}</td>
          </tr>
          <tr>
            <td>OS:</td>
            <td>{ticketOs}</td>
          </tr>
          <tr>
            <td>Browser:</td>
            <td>{ticketBrowser}</td>
          </tr>
          <tr>
            <td>IP:</td>
            <td>{ticketIp}</td>
          </tr>
          <tr>
            <td>Referrer:</td>
            <td className='device-referrer'>{ticketReferrer}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
